module.exports = __webpack_public_path__ + "static/media/marcaagua.c0fc2d86.jpg";